import { render, staticRenderFns } from "./ReviewsSummaryUnified.vue?vue&type=template&id=1b116bf8&"
import script from "./ReviewsSummaryUnified.vue?vue&type=script&lang=js&"
export * from "./ReviewsSummaryUnified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports